import PropTypes from 'prop-types';
import _orderBy from 'lodash/orderBy';

import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import styles from './investment-holdings-real-estate.module.scss';
import TableBasic from '../../../atoms/table-basic/index';
import format from '../../../../utils/format';

const className = augmentClassName(styles);

const InvestmentHoldingsRealEstate = ({ holdings }) => {
  const holdingsOrdered = _orderBy(holdings.filter(Boolean), ['weightPercent'], ['desc']);
  const asOfDate = holdings && holdings.length ? holdings[0].asOfDate : null;

  return (
    <CardModule
      data-analytics-componenttype="full-width-component"
      data-analytics-id="FW_InvestmentHoldingsRealEstate"
      data-analytics-section="component"
    >
      <CardModule.Header>
        Investment Holdings
        <CardModule.AsOfDate>{format.date(asOfDate)}</CardModule.AsOfDate>
      </CardModule.Header>
      <CardModule.Body {...className('table-scroll')}>
        <TableBasic flush>
          <caption {...className('sr-only')}>Top Ten Holdings Data</caption>
          <thead>
            <tr>
              <th {...className('text-nowrap', 'w-100')}>
                <span aria-hidden="true" {...className('text-left', 'pl-4')}>
                  Top Ten Holdings
                </span>
                <span {...className('sr-only')}>Name</span>
              </th>
              <th {...className('text-right', 'text-nowrap', 'pr-4')}>Portfolio Weight (%)</th>
            </tr>
          </thead>
          <tbody>
            {holdingsOrdered.map((holding, index) => (
              <tr
                data-key={`${holding.name || ''}-${index}`}
                key={`${holding.name || ''}-${index}`}
                {...className(index === holdingsOrdered.length - 1 ? 'border-bottom' : '')}
              >
                <th scope="row" {...className('text-left', 'pl-4')}>
                  {format.text(holding.name)}
                </th>
                <td {...className('text-right', 'pr-4', 'font-weight-bold')}>
                  {format.percent(holding.weightPercent)}
                </td>
              </tr>
            ))}
          </tbody>
        </TableBasic>
      </CardModule.Body>
      <CardModule.Footer {...className('text-right')}>
        <ButtonDisclosures module={'investment-holdings'} />
      </CardModule.Footer>
    </CardModule>
  );
};

InvestmentHoldingsRealEstate.defaultProps = {
  holdings: []
};

InvestmentHoldingsRealEstate.propTypes = {
  holdings: PropTypes.arrayOf(
    PropTypes.shape({
      asOfDate: PropTypes.string,
      name: PropTypes.string,
      weightPercent: PropTypes.number
    })
  )
};

export default InvestmentHoldingsRealEstate;
